<template>
  <section
    id="scroll-container"
    ref="scrollContainer"
    v-lenis-scroll
    class="subkoBanner"
    :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
  >
    <div class="overlay" />
    <div class="behnodubkosec1">
      <img
        class="blogo"
        :src="shopifyData.behnoLogo"
        alt="behnologo"
        loading="lazy"
        aria-hidden="true"
        aria-label="Behno Logo"
        width=""
        height=""
      />
    </div>
    <div class="behnodubkosec2">
      <img
        id="stuck"
        :src="shopifyData.sabkoLogo"
        alt="subkologo"
        loading="lazy"
        aria-hidden="true"
        aria-label="Subko Logo"
        width=""
        height=""
      />
    </div>
    <div class="behnodubkosec3">
      <img
        id="behnostuck"
        :src="shopifyData.behnoLogo"
        alt="behnologo"
        loading="lazy"
        aria-hidden="true"
        aria-label="Behno Logo"
        width=""
        height=""
      />
    </div>
    <div class="behnodubkosec4">
      <img
        id="stick"
        src="https://cdn.shopify.com/s/files/1/0689/7618/1550/files/BarSubkoBanner.png?v=1728460755"
        alt="behnostick"
        loading="lazy"
        aria-hidden="true"
        aria-label="Behno Stick"
        width=""
        height=""
      />
    </div>
    <div class="behnodubkosec5">
      <p class="custom_info">
        {{ shopifyData.custom_info }}
      </p>
    </div>
  </section>
</template>

<script>
// import Lenis from "@studio-freight/lenis";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth, // Track window width
    };
  },
  computed: {
    // Dynamic background image based on window width
    backgroundImage() {
      return this.windowWidth <= 676 ? this.shopifyData.mobBg : this.shopifyData.desktopBg;
    },
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);
    this.setupScrollAnimations();
    // this.initializeLenis();

    window.addEventListener('resize', this.updateBackgroundImage);
    window.addEventListener('load', () => {
      console.log('Window fully loaded, shopifyData:', this.shopifyData);
    });
  },
  beforeUnmount() {
    // Cleanup resize event listener
    window.removeEventListener('resize', this.updateBackgroundImage);
    if (this.scroller) {
      this.scroller.destroy();
    }
  },
  methods: {
    // Setup GSAP Animations with ScrollTrigger
    setupScrollAnimations() {
      // gsap.timeline({
      //       scrollTrigger: {
      //             trigger: ".behnodubkosec1",
      //             start: "top 0%",
      //             end: "20% top",
      //             scrub: 3,
      //             pin: true,
      //       },
      // });

      gsap.timeline({
        scrollTrigger: {
          trigger: '.behnodubkosec2',
          start: '50% 50%',
          end: 'bottom -50%',
          scrub: 3,
          pin: true,
          pinSpacing: false,
        },
      });

      gsap.timeline({
        scrollTrigger: {
          trigger: '.behnodubkosec3',
          start: '50% 50%',
          end: 'bottom top',
          pin: true,
          pinSpacing: false,
          scrub: 3,
        },
      });

      gsap.timeline({
        scrollTrigger: {
          trigger: '.behnodubkosec4',
          start: '50% 50%',
          end: 'bottom 50%',
          scrub: 3,
          pin: true,
          pinSpacing: false,
        },
      });

      // Media Queries for Small Screens (Mobile)
      const mm = gsap.matchMedia();

      mm.add('(min-width: 500px)', () => {
        gsap
          .timeline({
            scrollTrigger: {
              trigger: '.behnodubkosec2',
              start: '30% 40%',
              end: 'bottom 40%',
              // markers: true,
              scrub: 3,
            },
          })
          .to('#stuck', {
            x: 70,
            duration: 0.5,
          });

        gsap
          .timeline({
            scrollTrigger: {
              trigger: '.behnodubkosec3',
              start: '50% 80%',
              end: 'bottom 80%',
              scrub: 3,
            },
          })
          .to('#behnostuck', {
            x: -125,
            duration: 0.5,
          });
      });

      mm.add('(max-width: 500px)', () => {
        gsap
          .timeline({
            scrollTrigger: {
              trigger: '.behnodubkosec2',
              start: '30% 40%',
              end: 'bottom 40%',
              scrub: 3,
            },
          })
          .to('#stuck', {
            x: 55,
            duration: 0.5,
          });

        gsap
          .timeline({
            scrollTrigger: {
              trigger: '.behnodubkosec3',
              start: '50% 80%',
              end: 'bottom 80%',
              scrub: 3,
            },
          })
          .to('#behnostuck', {
            x: -70,
            duration: 0.5,
          });
      });
    },

    // Define the updateBackgroundImage method
    updateBackgroundImage() {
      this.windowWidth = window.innerWidth;
    },

    // initializeLenis() {
    //       this.lenis = new Lenis({
    //             smoothWheel: true,
    //             wheelMultiplier: 1.0, // Adjust scroll speed
    //             duration: 1.0, // Duration of the scroll
    //             easing: (t) => t, // Easing function (can be adjusted)
    //       });

    //       // Create a requestAnimationFrame loop
    //       const raf = (time) => {
    //             this.lenis.raf(time);
    //             requestAnimationFrame(raf);
    //       };
    //       requestAnimationFrame(raf);

    //       // Register GSAP ScrollTrigger with Lenis
    //       ScrollTrigger.scrollerProxy(this.lenis);

    //       // Refresh ScrollTrigger on window resize
    //       ScrollTrigger.addEventListener("refresh", () => this.lenis.update());
    // },
  },
};
</script>

<style scoped>
.subkoBanner {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 20px;
}

.overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  background-color: black;
  opacity: 0.3;
}

.behnodubkosec1,
.behnodubkosec2,
.behnodubkosec3,
.behnodubkosec4,
.behnodubkosec5 {
  position: relative;
  z-index: 3;
  display: grid;
  place-content: center;
}

.behnodubkosec1 {
  height: 70vh;
  justify-items: end;
}

.behnodubkosec2 {
  height: 65vh;
}

.behnodubkosec3 {
  height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.behnodubkosec4,
.behnodubkosec5 {
  height: 50vh;
  padding: 0 20px;
}

#stuck {
  max-width: 200px;
  width: 100%;
}

#behnostuck {
  max-width: 114px;
  width: 100%;
  margin-top: 5px;
}

#stick {
  transform: translateX(-52px);
  max-width: 60px;
  margin-top: 0px;
}

.custom_info {
  max-width: 380px;
  color: #fff;
  font-family: 'PP Editorial New', sans-serif;
  font-size: 16px;
  font-style: italic;
  font-weight: 200;
  line-height: 20.48px;
  letter-spacing: 0.02em;
  text-align: center;
}

.blogo {
  max-width: 170px;
}

@media screen and (max-width: 500px) {
  .subkoBanner {
    margin-top: 135px;
  }

  #stuck {
    max-width: 113px;
  }

  #behnostuck {
    max-width: 70px;
    margin-top: 0;
  }

  #stick {
    max-width: 35px;
    transform: translateX(-20px);
  }

  .blogo {
    max-width: 84px;
  }
}
</style>
